import { render, staticRenderFns } from "./passengers.vue?vue&type=template&id=723fa06a&scoped=true"
import script from "./passengers.vue?vue&type=script&lang=js"
export * from "./passengers.vue?vue&type=script&lang=js"
import style0 from "./passengers.vue?vue&type=style&index=0&id=723fa06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723fa06a",
  null
  
)

export default component.exports